// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2Dtfx","topBottomGutter":"Layout_topBottomGutter__222Nx"};